import { useState, useEffect } from 'react';

export default function useVoicemodMedia() {
  const [track, setTrack] = useState(null);
  const [isAvailable, setIsAvailable] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        // 1. Find "Voicemod Virtual Mic"
        const devices = await navigator.mediaDevices.enumerateDevices();
        const vmDevice = devices.find(d =>
          d.kind === 'audioinput' && /voicemod virtual mic/i.test(d.label)
        );
        
        if (!vmDevice) {
          console.warn('Voicemod Virtual Mic not found. Using default microphone.');
          // Fallback to default microphone
          try {
            const stream = await navigator.mediaDevices.getUserMedia({
              audio: true
            });
            setTrack(stream.getAudioTracks()[0]);
            setIsAvailable(true);
          } catch (err) {
            setError('No microphone access available');
            console.error('Microphone access denied:', err);
          }
          return;
        }

        // 2. Capture processed audio stream from Voicemod
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: { deviceId: vmDevice.deviceId }
        });
        setTrack(stream.getAudioTracks()[0]);
        setIsAvailable(true);
      } catch (err) {
        setError('Failed to access microphone');
        console.error('Error accessing Voicemod virtual mic:', err);
      }
    })();

    return () => {
      if (track) {
        track.stop();
      }
    };
  }, []);

  return { track, isAvailable, error };
} 